export const primaryColors = {
  primaryBase: '#1D2939',
};
